import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Award, Users, Truck } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function About() {
    return (
        <div className="bg-white" data-testid="about-page">
            <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
                <div className="text-xs font-mono-plex uppercase tracking-[0.2em] text-blue-700 mb-4">// About Us</div>
                <h1 className="font-heading font-black text-5xl md:text-6xl tracking-tighter text-slate-900 leading-tight">
                    Fueling Gujarat's industry, one drop at a time.
                </h1>
                <p className="mt-6 text-lg text-slate-600 max-w-3xl leading-relaxed">
                    Vaishali Fuels was founded in Vadodara with a simple mission — remove the queue, the paperwork and the guesswork from industrial diesel procurement. Instead of your operator driving to a petrol pump with a jerry can, we bring the pump to your gate.
                </p>

                <div className="mt-16 grid md:grid-cols-2 gap-10">
                    {[
                        { icon: Truck, title: "Our Own Fleet", body: "We own and operate every bowser. Uniformed, trained operators. GPS-tracked. Fire-safety compliant." },
                        { icon: ShieldCheck, title: "Metered Accuracy", body: "Weights & Measures certified flow meters. Every drop billed is a drop dispensed. Zero disputes." },
                        { icon: Award, title: "PESO Compliance", body: "Fully licensed under Petroleum & Explosives Safety Organisation norms. Insurance-backed operations." },
                        { icon: Users, title: "B2B First", body: "Recurring supply contracts, monthly billing, GST-compliant invoicing, dedicated relationship manager." },
                    ].map((v) => (
                        <div key={v.title} className="flex items-start gap-4">
                            <div className="w-11 h-11 bg-blue-700 flex items-center justify-center rounded-sm shrink-0">
                                <v.icon className="w-5 h-5 text-white" />
                            </div>
                            <div>
                                <h3 className="font-heading font-bold text-xl tracking-tight text-slate-900">{v.title}</h3>
                                <p className="mt-2 text-slate-600 leading-relaxed">{v.body}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-16 bg-slate-900 text-white p-10 rounded-sm">
                    <div className="grid md:grid-cols-3 gap-8">
                        <div>
                            <div className="font-heading font-black text-5xl text-yellow-400 tab-num">200+</div>
                            <div className="text-slate-400 mt-1 uppercase text-xs tracking-widest font-mono-plex">Active B2B Clients</div>
                        </div>
                        <div>
                            <div className="font-heading font-black text-5xl text-yellow-400 tab-num">5M+</div>
                            <div className="text-slate-400 mt-1 uppercase text-xs tracking-widest font-mono-plex">Litres Delivered</div>
                        </div>
                        <div>
                            <div className="font-heading font-black text-5xl text-yellow-400 tab-num">0</div>
                            <div className="text-slate-400 mt-1 uppercase text-xs tracking-widest font-mono-plex">Safety Incidents</div>
                        </div>
                    </div>
                </div>

                <div className="mt-16 flex flex-wrap gap-3">
                    <Link to="/order"><Button className="rounded-sm bg-blue-700 hover:bg-blue-800 h-11 px-6 font-bold uppercase tracking-wider" data-testid="about-order-btn">Place an Order</Button></Link>
                    <Link to="/contact"><Button variant="outline" className="rounded-sm border-slate-300 h-11 px-6 font-bold uppercase tracking-wider" data-testid="about-contact-btn">Talk to Sales</Button></Link>
                </div>
            </section>
        </div>
    );
}
